import { render } from "./FavStarButton.vue?vue&type=template&id=20e1e50c"
import script from "./FavStarButton.vue?vue&type=script&lang=js"
export * from "./FavStarButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__